import React from "react";
import { TwitterShareButton } from "react-share";
import PropTypes from "prop-types";

import "./shareExt.css";

const Twitter = ({ target, title }) => (
  <TwitterShareButton className="Button__share" title={title} url={target}>
    <div className="Button__share_twitter" />
  </TwitterShareButton>
);

Twitter.propTypes = {
  target: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Twitter;
